import axios from 'axios'

const authApi = axios.create({
    baseURL: 'https://identitytoolkit.googleapis.com/v1/accounts',
    params: {
        key: 'AIzaSyBJjEQEthNiYqjRvVNc_O2dTGzkEEDzf64'
    }
})

export default authApi